import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import currencyFormat from 'src/utils/formatCOP';
import onMouseResultsMap from 'src/utils/onMouseResultsMap';
import { useStyles, StyledTableCell } from '../reportsBoard/styles';
import LoadingRows from './LoadingRows';

const TableAAPPMarketShare = ({
  array = [], selectedDate, title, param, titleRow,
}) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="spanning table">
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={6} align="center">
                {titleRow}
              </StyledTableCell>
              <StyledTableCell colSpan={2} align="center">
                MS Dic
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear()}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 1}</StyledTableCell>
              <StyledTableCell align="right">AA</StyledTableCell>
              <StyledTableCell align="right">%PPTO</StyledTableCell>
              <StyledTableCell align="right">%MS</StyledTableCell>
              <StyledTableCell align="right">%AA</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {array.length > 0 ? (
              array.map((row) => (
                <TableRow key={Math.random()}>
                  <TableCell align="left">{row[param].toUpperCase()}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.VALOR_1, 10))}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.VALOR_2, 10))}</TableCell>
                  <TableCell align="right">
                    {(+row.AA).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {(+row.PPTO * 100).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {(+row.MS * 100).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {(+row.MSAA).toFixed(2)}
                    %
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                  <TableCell><LoadingRows /></TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>TOTAL</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'VALOR_1')}</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'VALOR_2')}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableAAPPMarketShare;
